import React from "react";
import BioSection from "../components/BioSection";
import Timeline from "../components/Timeline";

export default function Trajetoria() {
  return (
    <div data-testid="page-trajetoria" className="pt-24 md:pt-32 bg-[#FAF9F6]">
      <header className="max-w-7xl mx-auto px-6 md:px-10 pb-10 md:pb-16">
        <div className="text-[11px] uppercase tracking-[0.28em] text-[#003F88] font-semibold">
          <span className="accent-line" />
          Trajetória política
        </div>
        <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6">
          Do Jambeiro à <em className="italic font-light">presidência</em> da Câmara.
        </h1>
      </header>
      <BioSection />
      <Timeline />
    </div>
  );
}
